var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"users-stats"},[_c('div',{staticClass:"begin bg-white p-6 rounded shadow"},[_c('div',{staticClass:"title text-xl"},[_vm._v(_vm._s(_vm.$t('usersMenu')))]),_c('div',{staticClass:"chart"},[_c('apexcharts',{attrs:{"type":"line","height":"350","options":_vm.chartOptions,"series":_vm.series}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }